import React from "react";
import Link from "next/link";
import styled from "styled-components";
import { useRouter } from "next/router";
import { getPathName } from "../helpers/utils";

const BreadCrumb = styled.ul`
  color: ${(props) => (props.isMobile ? "#000" : "#fff")};
  padding-left: 0px;
  font-family: "Lato";
  font-size: 14px;
  margin: 0px;
  overflow: hidden;
`;

const BreadCrumbItem = styled.li`
  display: inline-block;
`;

const BreadCrumbArrow = styled.span`
  padding: 8px;
`;

const BreadCrumbLink = styled.a`
  font-family: "Lato";
  font-size: 14px;
  color: ${(props) =>
    props.active === "active" && !props.isMobile
      ? "#ffc101"
      : !props.isMobile
      ? "#fff"
      : "#000"};

  text-decoration: none;
  cursor: pointer;
  text-transform: capitalize;
  ${(props) =>
    props.active === "active" &&
    props.isMobile &&
    `
      color: #f9637a;
      font-weight: bold;
      pointer-events: none;
      `}

  ${(props) =>
    props.active === "active" && `pointer-events: none; cursor: crosshair`}

  &:active {
    color: #ffc101;
    ${(props) =>
      props.active === "active" &&
      props.isMobile &&
      `
      color: #f9637a;
      font-weight: bold;
      `}
  }
`;

export default function BreadCrums({ isMobile, category, templateName }) {
  const router = useRouter();
  const crumsMap = !!category
    ? [category, templateName]
    : router.query.tagId
    ? [router.query.id, router.query.tagId]
    : [router.query.id];
  return (
    <BreadCrumb isMobile={isMobile}>
      <BreadCrumbItem>
        <Link href="https://www.picmaker.com" passHref>
          <BreadCrumbLink isMobile={isMobile}>Home</BreadCrumbLink>
        </Link>
      </BreadCrumbItem>
      <BreadCrumbItem>
        <BreadCrumbArrow>
          <i>{">"}</i>
        </BreadCrumbArrow>
        <Link href="/" passHref>
          <BreadCrumbLink isMobile={isMobile}>Templates</BreadCrumbLink>
        </Link>
      </BreadCrumbItem>
      {crumsMap.map((item, index) => (
        <BreadCrumbItem key={index}>
          <BreadCrumbArrow>
            <i>{">"}</i>
          </BreadCrumbArrow>
          {index === crumsMap.length - 1 ? (
            <BreadCrumbLink
              active={index === crumsMap.length - 1 && "active"}
              isMobile={isMobile}
            >
              {getPathName(item)}
            </BreadCrumbLink>
          ) : (
            <Link href={`/${item}`} passHref>
              <BreadCrumbLink
                active={index === crumsMap.length - 1 && "active"}
                isMobile={isMobile}
              >
                {getPathName(item)}
              </BreadCrumbLink>
            </Link>
          )}
        </BreadCrumbItem>
      ))}
    </BreadCrumb>
  );
}
